import React from 'react';
import { Box } from '@mui/material';
import { ChevronRightRounded } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import VoiceList from '../VoiceList';
import { TrendingVoicesContainer } from './index.style';
import VoiceSkeleton from '../LoadingSkeleton/VoiceSkeleton';

const TrendingVoices = ({
  onSeeAll,
  voicesList,
  section,
  onChangeVoice,
  onClose,
  isApplyPreset,
  isInitialLoading,
  isCommunity,
  onFetchFavouriteVoices,
  isDialog,
  favouriteVoiceCodes,
  onFavoriteToggleRequest,
  onHandleFavoriteProcessingComplete,
  onErrorProcessingFavouriteVoices,
  activeVoiceCode,
  prizes,
  isOpenFromSpeakerSettings = false,
}) => {
  const { t } = useTranslation();
  const listVoices = voicesList?.filter(
    (voice) => voice?.stats?.totalCredits > 0,
  );

  return (
    <TrendingVoicesContainer>
      <Box onClick={onSeeAll} className="trending-voice-header">
        <Typography variant="body-20-bold" color={COLOR.darkGray}>
          {t('trendingVoice')}
        </Typography>
        <ChevronRightRounded sx={{ color: COLOR.indigo[64], fontSize: 24 }} />
      </Box>
      {isInitialLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {Array.from({ length: 5 }).map(() => (
            <VoiceSkeleton />
          ))}
        </div>
      ) : (
        <VoiceList
          voices={listVoices}
          isCard={false}
          isTrending
          isCommunity={isCommunity}
          section={section}
          onChangeVoice={onChangeVoice}
          onClose={onClose}
          isApplyPreset={isApplyPreset}
          onFetchFavouriteVoices={onFetchFavouriteVoices}
          isDialog={isDialog}
          favouriteVoiceCodes={favouriteVoiceCodes}
          onFavoriteToggleRequest={onFavoriteToggleRequest}
          onHandleFavoriteProcessingComplete={
            onHandleFavoriteProcessingComplete
          }
          onErrorProcessingFavouriteVoices={onErrorProcessingFavouriteVoices}
          activeVoiceCode={activeVoiceCode}
          prizes={prizes}
          isOpenFromSpeakerSettings={isOpenFromSpeakerSettings}
        />
      )}
    </TrendingVoicesContainer>
  );
};

export default TrendingVoices;
